import { render, staticRenderFns } from "./addContent.vue?vue&type=template&id=7cf521ae&scoped=true&"
import script from "./addContent.vue?vue&type=script&lang=js&"
export * from "./addContent.vue?vue&type=script&lang=js&"
import style0 from "./addContent.vue?vue&type=style&index=0&id=7cf521ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf521ae",
  null
  
)

export default component.exports